module.exports = __webpack_public_path__ + "static/media/image1.9095a738.jpeg";